import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import I18N from './I18N';
const NotFoundPage = ({ message, backTo, backLabel, }) => (_jsxs("div", { className: "p-4", "data-testid": "not-found-page", children: [_jsx("h1", { className: "page-header mb-2", children: _jsx(I18N, { children: message }) }), _jsx(Link, { to: backTo, replace: true, children: _jsx(I18N, { children: backLabel }) })] }));
export default NotFoundPage;
